import {
    initializeToolTipValidation, 
    initializePhoneFormatting,
    getFormData,
} from "./checkoutFormHandler.js";
import {showModal} from "../helpers/modal.js";
import {logClient} from '../helpers/adminHelper.js';

const urlParams = new URLSearchParams(window.location.search);
const message = urlParams.get("message");
const code = urlParams.get("code");
const timestamp = urlParams.get("timestamp");

const contactReason = document.getElementById("contactReason");
const generalMessageSection = document.getElementById("generalMessageSection");
const generalMessageField = document.getElementById("generalMessage");
const issueDetailsSection = document.getElementById("issueDetailsSection");
const errorMessageField = document.getElementById("errorMessage");
const errorCodeField = document.getElementById("errorCode");
const issueDetailsField = document.getElementById("issueDetails");
const contactForm = document.getElementById("contactForm");
const phoneInput = document.getElementById("phone");
const emailInput = document.getElementById("email");
const contactMethodSelect = document.getElementById("contactMethod");
const timestampField = document.getElementById("timestamp");
const clearForm = document.getElementById("clearForm");

initializeToolTipValidation(contactForm);
initializePhoneFormatting(phoneInput);

// Intercept form submission
contactForm.addEventListener('submit', async (event) => {
    event.preventDefault();  // Prevent the default form submission behavior

    const formData = new FormData(contactForm);

    // Convert formData to an object
    const contactDetails = {};
    formData.forEach((value, key) => {
        contactDetails[key] = value;
    });

    try {
        const response = await fetch('/api/admin/admin-contact-form', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(contactDetails),
        });

        const result = await response.json();

        if (response.ok) {
            showModal('<p>Thank you for reaching out! Your message has been successfully sent.</p>');
            formReset(true);

        } else {

            throw {
                errorCode: result.errorCode || 'CONTACT_FORM_ERROR',
                message: result.message || 'Issue with submitting contact form.',
            }
        }
    } catch (error) {

        logClient('contactForm', 'Error during form submission:', error);
        
        showModal('<p>There was an issue submitting the form. Please try again later. If the issue persists, please try contacting us by phone.</p>');
    }
});

function formReset (clearURL = false) {
    contactForm.reset();

    emailInput.removeAttribute("required");
    phoneInput.removeAttribute("required");
    generalMessageField.removeAttribute("required");
    issueDetailsField.removeAttribute("required");

    emailInput.setCustomValidity("");
    phoneInput.setCustomValidity("");
    generalMessageField.setCustomValidity("");
    issueDetailsField.setCustomValidity("");

    emailInput.placeholder = "";
    phoneInput.placeholder = "";

    generalMessageSection.style.display = "none";
    issueDetailsSection.style.display = "none";

    contactReason.value = "";

    if (clearURL) {
        window.history.replaceState({}, document.title, window.location.pathname);
    }
}

clearForm.addEventListener("click", (e) => {
    e.preventDefault();
    showModal('<h4>Are you sure you want to clear all the form fields?</h4>', {
        confirmCallback: () => {
            formReset(true);
        },
        cancelCallback: () => {},
        yesText: 'Clear Form',
        noText: 'Cancel',
    
    });
});



if (message) {
    errorMessageField.value = message;
    contactReason.value = "issue";

    // Fetch session data and prefill form fields
    try {
        const sessionData = await getFormData();

        console.log("Session data:", sessionData);

        if (sessionData) {
            document.getElementById("firstName").value = sessionData.checkoutForm.CUSTOMERFIRSTNAME || "";
            document.getElementById("lastName").value = sessionData.checkoutForm.CUSTOMERLASTNAME || "";
            document.getElementById("email").value = sessionData.checkoutForm.CUSTOMEREMAIL || "";
            document.getElementById("phone").value = sessionData.checkoutForm.CUSTOMERPHONE || "";
        } else {
            console.warn("No session data available to prefill the form.");
        }
    } catch (error) {
        console.error("Error fetching session data:", error);
    }
}

if (code && code !== "null" && code !== "undefined") {
    errorCodeField.value = code;
} else {
    errorCodeField.value = "";  
}

if (timestamp) {
    timestampField.value = timestamp;
}

function toggleRequirement() {
    if (contactMethodSelect.value === "phone") {
        emailInput.removeAttribute("required");
        emailInput.placeholder = "";
        emailInput.setCustomValidity("");
        phoneInput.setAttribute("required", "true");
        phoneInput.placeholder = "Phone number required.";
    } else if (contactMethodSelect.value === "email" || contactReason.value === "issue") {
        phoneInput.removeAttribute("required");
        phoneInput.placeholder = "";
        phoneInput.setCustomValidity("");
        emailInput.setAttribute("required", "true");
        emailInput.placeholder = "Email required.";
    }
    else {
        phoneInput.removeAttribute("required");
        phoneInput.setCustomValidity("");
        phoneInput.placeholder = "";
        emailInput.removeAttribute("required");
        emailInput.setCustomValidity("");
        emailInput.placeholder = "";
    }
}


toggleRequirement();

contactReason.addEventListener("change", toggleRequirement);
contactMethodSelect.addEventListener("change", toggleRequirement);

function toggleFields() {
    if (contactReason.value === "inquiry") {
        generalMessageSection.style.display = "grid";
        generalMessageField.setAttribute("required", "true");
        generalMessageField.placeholder = "Please enter your message here.";
        issueDetailsSection.style.display = "none";
        issueDetailsField.removeAttribute("required");
        issueDetailsField.value = "";
        errorMessageField.value = "";
        errorCodeField.value = "";
    } else if (contactReason.value === "issue") {
        generalMessageSection.style.display = "none";
        generalMessageField.value = "";
        generalMessageField.removeAttribute("required");
        emailInput.setAttribute("required", "true");
        emailInput.placeholder = "Email required if reporting an issue.";
        issueDetailsSection.style.display = "grid";
        issueDetailsField.setAttribute("required", "true");
        issueDetailsField.placeholder = "Please provide a brief description of the issue.";
    } else {
        generalMessageSection.style.display = "none";
        issueDetailsSection.style.display = "none";
    }
}

toggleFields();

contactReason.addEventListener("change", toggleFields);